module.exports = __webpack_public_path__ + "static/media/dateIcon.e5394ea6.svg";